<template>
    <h1>Room {{activeLeg.leg}}: {{activePackage.content.DisplayName}}</h1>


    <div v-if="isLoading"
         class="position-relative d-flex justify-content-center">
        <loader v-bind:message="'Raking the bunkers...'"></loader>

    </div>
    <div v-else>

        <div v-if="!showAvailability" class="row">
            <div class="col-24"
                 v-for="(date, index) in dates"
                 v-bind:key="index">
                <div class="date-panel p-4 mb-3"
                     v-bind:class="{'on' : date.checked}">
                    <div class="row">
                        <div class="col-2">
                            <input type="checkbox"
                                   v-model="date.checked" />

                        </div>

                        <div class="col-6">
                            <div v-on:click="date.checked = !date.checked">
                                <span class="time-date-day">{{formatDateLine1(date.date)}}</span>
                                <span class="time-date-year">{{formatDateLine2(date.date)}}</span>
                            </div>
                        </div>

                        <div class="col-16">
                            <div v-if="date.checked">
                                <div class="player-count d-flex flex-row row align-content-center">
                                    <div class="col-6"> Players: </div>

                                    <div v-for="(guestCount) in guestCounts"
                                         v-bind:key="guestCount"
                                         class="col">
                                        <label>

                                            <input type="radio"
                                                   v-bind:checked="((date.packageCount == undefined || date.packageCount == null) && guestCount == 1) ||(date.packageCount == guestCount)"
                                                   v-bind:value="guestCount"
                                                   v-model="date.packageCount" />

                                            {{guestCount}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="row"
             v-if="showAvailability">


            <div class="btn-container">
                <div class="date-selector"
                     v-for="(date, di) in activeDates">

                    <span v-bind:class="{'modal-button--active' : dateIndex == di}"
                          class="btn modal-button ">
                        <span class="top">
                            {{formatDateTop(date.date)}}
                        </span>
                        <span class="bottom">
                            {{formatDateBottom(date.date)}}

                        </span>
                    </span>
                </div>
            </div>


            <div v-if="currentDate.availability">


                <h3>Tee-off time</h3>
                <div v-for="(aa, index) in currentDate.availability.item">
                    <div v-for="(a, index) in aa.Availability">


                        <div class="row ">

                            <div class="col-md-24 ">
                                <div class="row mb-4">
                                    <div class="col-md-12">
                                        <button class="btn btn--block modal-button"
                                                v-bind:class="{'modal-button--active' : (a.timeOfDay=='AM') ||  (a.timeOfDay == undefined && defaultTimeOfDay == 'AM')}"
                                                v-on:click="onSetTimeOfDay(a, 'AM')">
                                            Morning
                                        </button>
                                    </div>
                                    <div class="col-md-12">
                                        <button class="btn btn--block modal-button"
                                                v-bind:class="{'modal-button--active' : (a.timeOfDay=='PM') || (a.timeOfDay == undefined && defaultTimeOfDay == 'PM')}"
                                                v-on:click="onSetTimeOfDay(a, 'PM')">
                                            Afternoon
                                        </button>
                                    </div>
                                </div>

                                <div class="row" v-if="a.timeOfDay=='AM' || (a.timeOfDay == undefined && defaultTimeOfDay == 'AM')">
                                    <span class="col-12 col-md-6 col-xl-4" v-for="t in a.AM">
                                        <span class="time-slot"
                                              v-bind:class="{'time-slot--active': isSelected(t), 'timeslot--disabled' : checkIsDisabled(t)}"
                                              v-on:click="onSelection(t)">

                                            {{formatTime(t.Time)}}

                                        </span>
                                    </span>
                                </div>

                                <div class="row" v-if="a.timeOfDay==='PM' || (a.timeOfDay == undefined && defaultTimeOfDay == 'PM')">
                                    <span class="col-12 col-md-6 col-xl-4" v-for="t in a.PM">
                                        <span class="time-slot"
                                              v-bind:class="{'time-slot--active': isSelected(t), 'timeslot--disabled' : checkIsDisabled(t)}"
                                              v-on:click="onSelection(t)">

                                            {{formatTime(t.Time)}}

                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>

    </div>

    <div class="row mt-8">

        <div class="col-12 d-flex justify-content-start">
            <button class="btn btn--transparent btn--back" type="button" v-on:click="onClose()">
                Close
            </button>

        </div>


        <div class="col-12 d-flex justify-content-end">
            <button class="btn btn--slate-blue btn--continue" type="button" v-if="canShowNext()" v-on:click="onNext()">
                Continue
            </button>


            <button class="btn btn--slate-blue btn--continue" v-on:click="onSubmit()" v-if="!canShowNext()">
                Continue
            </button>

        </div>
    </div>

</template>

<script>

    import { store } from '../store/index';
    import Loader from '@/shared/components/Loader.vue';


    export default {
        name: 'GolfAvailability',
        props: {
            activeLeg: Object,
            activePackage: Object

        },
        components: {
            Loader,

        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            guestCounts() {
                let result = [];
                let guests = this.activeLeg.guestQuota.Adults + this.activeLeg.guestQuota.Children;

                for (let i = 1; i <= guests; i++) {
                    result.push(i);
                }

                return result;
            },
            activeDates() {

                return this.dates.filter(item => item.checked);
            },
            currentDate() {
                return this.activeDates[this.dateIndex];
            }
        },
        data() {

            return {

                defaultTimeOfDay: 'AM',
                isLoading: false,
                dates: [],
                showAvailability: false,
                availability: null,
                dateIndex: -1
            }
        },
        mounted() {
            this.setDates();
        },
        methods: {
            onClose() {
                this.$parent.$emit('close');
            },
            setDates() {
                let result = [];

                for (let i = 0; i < +(this.booking.numberOfNights) + 1; i++) {
                    let date = moment(this.booking.arrivalDate).add(i, 'd');
                    result.push({ date, checked: false, packageCount: 1 });
                }

                this.dates = result;
            },
            canShowNext() {

                return this.dateIndex < 0 || (this.dateIndex) < (this.activeDates.length - 1);
            },
            onNext() {

                if (this.activeDates != null && this.activeDates.length) {

                    this.isLoading = true;
                    this.showAvailability = true;
                    this.dateIndex = this.dateIndex + 1;

                    let activeDate = this.activeDates[this.dateIndex];
                    this.getAvailability(activeDate);

                } else {
                    this.onClose();
                }

            },

            getAvailability(activeDate) {



                if (activeDate.availability === undefined || activeDate.availability === null) {
                    var payload = {
                        sessionId: this.session.Id,
                        startDate: moment(activeDate.date).format("YYYY-MM-DD"),
                        numberOfDays: 1,
                        rounds: [
                            {
                                number: 1,
                                PlayerCount: activeDate.packageCount
                            }]
                    }
                    store.dispatch('fetchGolfPackageAvailability', payload)
                        .then((t) => {
                            activeDate.availability = t;
                            this.isLoading = false;
                        })


                }
                else {

                    this.isLoading = false;
                }
            },
            onSubmit() {
                //call the add here...
                var gaItemTracking = {};

                //For adding from a modal pop up
                this.$emit('track', gaItemTracking);


                let o = this;
                let payload = {
                    item: o.activePackage,
                    leg: o.activeLeg.leg,
                    quantity: this.activeDates.reduce(function (acc, ad) {
                        return acc + (+ad.packageCount);
                    }, 0),
                    selections: this.activeDates.map(function (ad) {
                        return {
                          
                            date: ad.date,
                            quantity: ad.packageCount,
                            selection: ad.selection,
                        }
                    })
                };

                

                store.dispatch("selectGolfPackage", payload).then(() => {
                    this.onClose();
                });
                    


            },



            formatDateLine1(date) {
                return moment(date).format('dddd Do');
            },
            formatDateLine2(date) {

                return moment(date).format('MMMM YYYY');
            },
            formatDateTop(input) {
                let date = moment(input);
                return date.format("ddd Do");
            },
            formatDateBottom(input) {

                let date = moment(input);
                return date.format("MMM YY");
            },
            formatTime(dateTime) {

                let date = moment(dateTime);
                return date.format("HH:mm");
            },


            checkIsDisabled(t) {
                if (t.Reference == null) {
                    return true;
                }




                return false;
            },

            onSelection(t) {

                if (t.Reference == null) {
                    return;
                }

                let date = this.activeDates[this.dateIndex];

                date.selection = t;


            },


            isSelected(t) {
                if (t.Reference == null) {
                    return false;
                }
                if (this.currentDate.selection != undefined && this.currentDate.selection != null) {

                    return this.currentDate.selection.Reference == t.Reference;

                }

                return false;
            },
            onSetTimeOfDay(a, timeOfDay) {

                a.timeOfDay = timeOfDay;
            },






        }
    }
</script>

<style scoped>
    .player-count {
        font-size: 14px;
        text-transform: uppercase;
        text-align: left;
        font-weight: bold;
    }

    .time-date-day,
    .time-date-year {
        display: block;
        width: 100%;
        font-size: 14px;
        text-transform: uppercase;
        text-align: left;
        cursor: pointer;
    }

    .time-date-day {
        font-weight: bold;
    }

    .time-date-year {
        font-weight: 400;
    }

    .date-panel {
        background: #fff;
    }


        .date-panel.on {
            background: #425260;
            color: #fff;
        }

        .date-panel input[type="checkbox"] {
            height: 24px;
            width: 24px;
            cursor: pointer;
        }

    .time-slot {
        padding: 15px;
        display: block;
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        cursor: pointer;
    }


        .time-slot.time-slot--unavailable {
            color: rgba(66, 82, 96, 0.15);
            cursor: not-allowed;
        }


        .time-slot:not(.time-slot--unavailable):hover,
        .time-slot.time-slot--active {
            background-color: #425260;
            color: #fff;
        }

    .timeslot--disabled,
    .timeslot--disabled:hover {
        background: #ddd !important;
        color: #000 !important;
        cursor: default;
    }



    .date-selector {
        font-size: 14px;
        font-family: Montserrat;
    }


    .modal-button {
        background-color: #fff;
        position: relative;
        color: #000;
        border-color: #fff;
        margin-bottom: 30px !important;
    }


        .modal-button:after {
            border-top: 10px solid #fff;
            display: block;
            position: absolute;
            content: ' ';
            bottom: -12px;
            left: 50%;
            transform: translateX(-50%);
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            z-index: 10;
        }



    .modal-botton:hover,
    .modal-button--active {
        background-color: #425260;
        border-color: #425260;
        color: #fff;
    }

        .modal-botton:hover,
        .modal-button--active:after {
            border-top: 10px solid #425260;
        }
</style>
